import styles from "./ProductSupport.module.scss";
import { MyCases48PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/MyCases48PxOutlined";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
type Props = {
  url: string;
};

export const ProductSupportUI = ({ url }: Props) => (
  <div
    data-testid="product-support"
    className={styles.container}
    data-component="ProductSupport"
  >
    <section className={styles["productSupport"]}>
      <div className={styles["productSupport__content"]}>
        <MyCases48PxOutlinedIcon />
        <h2 className={styles["productSupport__headline"]}>Laptop support</h2>
        <p>Get up and running smoothly with our product guide and support</p>
        <UnderlinedButton
          tag="a"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          Find out more
        </UnderlinedButton>
      </div>
    </section>
  </div>
);
